import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./performanceApiClient";

export const listReviews = async (params = {}) =>
  getRequest("/reviews", { params });

export const getReviewById = async (reviewId) =>
  getRequest(`/reviews/${reviewId}`);

export const createReview = async (payload) => postRequest("/reviews", payload);

export const generatePerformanceReviews = async (payload) =>
  postRequest("/reviews/generate", payload);

export const updateReview = async (reviewId, payload) =>
  putRequest(`/reviews/${reviewId}`, payload);

export const submitReview = async (reviewId) =>
  postRequest(`/reviews/${reviewId}/submit`, {});

export const acknowledgeReview = async (reviewId, payload = {}) =>
  postRequest(`/reviews/${reviewId}/acknowledge`, payload);

export const finalizeReview = async (reviewId) =>
  postRequest(`/reviews/${reviewId}/finalize`, {});

export const approveIncrement = async (reviewId, payload = {}) =>
  postRequest(`/reviews/${reviewId}/increment/approve`, payload);

export const approvePromotion = async (reviewId, payload = {}) =>
  postRequest(`/reviews/${reviewId}/promotion/approve`, payload);

export const getReviewAnalytics = async () => getRequest("/reviews/analytics");

export const saveSelfAssessment = async (reviewId, payload = {}) =>
  putRequest(`/reviews/${reviewId}/self-assessment`, payload);

export const submitSelfAssessment = async (reviewId, payload = {}) =>
  postRequest(`/reviews/${reviewId}/self-assessment/submit`, payload);

export const saveManagerAssessment = async (reviewId, payload = {}) =>
  putRequest(`/reviews/${reviewId}/manager-assessment`, payload);

export const submitManagerAssessment = async (reviewId, payload = {}) =>
  postRequest(`/reviews/${reviewId}/manager-assessment/submit`, payload);

export const saveSecondLevelAssessment = async (reviewId, payload = {}) =>
  putRequest(`/reviews/${reviewId}/second-level-assessment`, payload);

export const submitSecondLevelAssessment = async (reviewId, payload = {}) =>
  postRequest(`/reviews/${reviewId}/second-level-assessment/submit`, payload);

export const sendBackPerformanceReview = async (reviewId, payload = {}) =>
  postRequest(`/reviews/${reviewId}/send-back`, payload);

export const recalculatePerformanceReview = async (reviewId) =>
  postRequest(`/reviews/${reviewId}/recalculate`, {});

export const applyPerformanceRestriction = async (reviewId, payload = {}) =>
  postRequest(`/reviews/${reviewId}/restrictions`, payload);

export const removePerformanceRestriction = async (reviewId) =>
  deleteRequest(`/reviews/${reviewId}/restrictions`);

export const getPerformanceReviewHistory = async (reviewId) =>
  getRequest(`/reviews/${reviewId}/history`);

export default {
  listReviews,
  getReviewById,
  createReview,
  generatePerformanceReviews,
  updateReview,
  submitReview,
  acknowledgeReview,
  finalizeReview,
  approveIncrement,
  approvePromotion,
  getReviewAnalytics,
  saveSelfAssessment,
  submitSelfAssessment,
  saveManagerAssessment,
  submitManagerAssessment,
  saveSecondLevelAssessment,
  submitSecondLevelAssessment,
  sendBackPerformanceReview,
  recalculatePerformanceReview,
  applyPerformanceRestriction,
  removePerformanceRestriction,
  getPerformanceReviewHistory,
};
